import styled from "@emotion/styled";
import { menuTheme } from "../../../menu/styled/menuTheme";
import { TypeRampV2 } from "../../../typography";
export const SelectedOptionFacade = styled(TypeRampV2)`
    font-size: ${_ref => {
  let {
    themeMode
  } = _ref;
  return menuTheme.fontSize(themeMode);
}};
    line-height: 18px;
    min-width: 0;
    overflow-wrap: break-word;
    color: var(--sds--form--color--value, inherit);
`;
//# sourceMappingURL=SelectedOptionFacade.js.map